import { useMemo } from 'react'

import { useSelectedProjectPremises } from '@/api/models/main/hooks/useSelectedProjectPremises'
import { PremiseTypeAlias } from '@/api/models/requests/lib/requests.types'

export const useParkingPlaces = () => {
  const { withoutGuestParking: premises } = useSelectedProjectPremises()

  const parkingPlaces = useMemo(() => {
    const parkingPlaces = premises.filter(
      premise => premise.typeAlias === PremiseTypeAlias.CarSpace
    )

    if (parkingPlaces) {
      return parkingPlaces.map(parkingPlace => ({
        id: parkingPlace.id,
        label: parkingPlace.name,
        value: parkingPlace.name
      }))
    }
    return []
  }, [premises])

  return {
    parkingPlaces
  }
}
